// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","netflixroulette":"App_netflixroulette__3TC04","headerList":"App_headerList__1YvOt","headerListItem":"App_headerListItem__kormM","link":"App_link__TB6Cl"};